import DateUtils from "../../../../shared/utils/DateUtils";
import { formatPercentageInputValue, percentageMask } from "../../utils/admin-utils";

export const adjustmentFormConfig = ({ adjustment } = {}) => {
	return [
		{
			fields: [
				{
					name: "effectiveStartDate",
					label: "Início da vigência *",
					type: "date",
					placeholder: "26/05/2026",
					defaultValue: adjustment?.effectiveStartDate
						? new Date(`${adjustment.effectiveStartDate}T00:00:00`)
						: DateUtils.getDateDaysFromToday(1),
					columns: 12,
					actions: [
						{
							targetField: "effectiveEndDate",
							clearTargetOnChange: true,
							event: "complete",
							isTriggered: value => Boolean(value),
							execute: value => Promise.resolve(value),
							getValue: value => value
						}
					]
				},
				{
					name: "effectiveEndDate",
					label: "Término da vigência *",
					type: "date",
					placeholder: "26/05/2026",
					defaultValue: adjustment?.effectiveEndDate
						? new Date(`${adjustment.effectiveEndDate}T00:00:00`)
						: DateUtils.getDateDaysFromToday(1),
					columns: 12
				},
				{
					name: "adjustment",
					label: "% de reajuste *",
					type: "text",
					placeholder: "0",
					defaultValue: formatPercentageInputValue(adjustment?.adjustment),
					columns: 12,
					onChange: percentageMask
				}
			]
		}
	];
};